import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid , Segment , Header , Button } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import { changeUiState } from '../../actions/uiActions';
import QuoteCart from './quoteCart';

const styles = {
  quoteWrapper : {
    paddingLeft : '3%',
    display : 'flex',
    flexDirection : 'column',
    alignItems : 'center',
    position : 'relative'
  },
  trialButton : {
    backgroundColor : ThemeColorSetting.red,
    color : 'white'
  },
  quoteFooter : {
    display : 'flex',
    justifyContent : 'center',
    alignItems : 'center',
  }
}

class QuoteDisplay extends Component {
  componentWillMount(){
    const { changeUiState } = this.props;
    changeUiState([{ keys : ['tempData','quote'] , value : { totalPrice : 0 , software : [] , hardware : [] , service : [] } }]);
  }
  shouldComponentUpdate(nextProps){
    const { quote } = this.props;
    return JSON.stringify(quote) !== JSON.stringify(nextProps.quote);
  }
  render(){
    const { string , quote } = this.props;
    return (
      <Grid.Column style={styles.quoteWrapper} width={4} className="computer tablet only">
        <Segment.Group style={{ width : '16%' , position : 'fixed' }}>
          <Segment>
            {(quote !== undefined) ? <Header as='h1'>{`${string['quotePrice']} : $${quote['totalPrice']}`}</Header> : null}
          </Segment>
          <Segment>{(quote !== undefined && quote.totalPrice > 0) ? <QuoteCart quote={quote}/> : string['noItem']}</Segment>
          <Segment style={styles.quoteFooter}><a href="https://dashboard.kios.tech/auth/signup"><Button style={styles.trialButton} size={'big'}>{string['signupNow']}</Button></a></Segment>
        </Segment.Group>
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    quote : state.ui.tempData.quote
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ changeUiState },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(QuoteDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/price/quoteDisplay.js
 **/